import {LOCALE_CATEGORIES} from "@/assets/locales/categories.ts";
import {defineAsyncComponent} from "vue";
import {RouteRecordRaw} from "vue-router";


export namespace ContactUsRoute {
  export function record(): RouteRecordRaw {
    return {
      name: 'contact',
      path: '/workspace/:workspaceId/contact',
      component: defineAsyncComponent(() => import("./ContactView.vue")),
      meta: {
        navLoader: true,
        hasNav: true,
        localeCategories: [
          LOCALE_CATEGORIES.CONTACT_US,
          LOCALE_CATEGORIES.ERRORS,
        ]
      }
    };
  }

  export function location(workspaceId: number, query?: any) {
    return {name: 'contact', params: {workspaceId}, query};
  }
}
